<template>
    <v-card v-if="displayMe" flat :img="`${publicPath}images/bg-xp-popup.png`" class="rounded-lg">
        <v-row class="ma-0">
            <v-col v-if="$vuetify.breakpoint.smAndUp" cols="2" class="text-center">
                <v-card-title class="d-block pr-0">
                    <v-img
                        v-if="imageSrc"
                        :src="`${publicPath}${imageSrc}`"
                        class="d-inline-block"
                        :aspect-ratio="1"
                        width="52"
                        height="52"
                    />

                    <v-icon x-large class="white--text" v-else-if="icon">{{icon}}</v-icon>
                </v-card-title>
            </v-col>

            <v-col cols="12" sm="10">
                <v-row class="ma-0">
                    <v-col class="pa-0">
                        <v-card-title class="white--text">
                            {{$t(title)}}
                        </v-card-title>

                        <v-card-text class="white--text">
                            {{text}}
                        </v-card-text>
                    </v-col>

                    <v-col class="flex-grow-0 flex-shrink-1 pa-0">
                        <v-card-title>
                            <v-btn icon @click="closeBanner">
                                <v-icon class="white--text">fas fa-times</v-icon>
                            </v-btn>
                        </v-card-title>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
    export default {
        props: {
            title: null,
            text: null,
            icon: null,
            imageSrc: null,
        },
        data() {
            return {
                publicPath: process.env.BASE_URL,
                displayMe: true,
            };
        },
        methods: {
            closeBanner() {
                this.displayMe = false;
                this.$emit('close');
            },
        },
    };
</script>